import { takeLatest, call, put } from 'redux-saga/effects';
import { fetchLouncherInstallerFailure, fetchLouncherInstallerFulfilled, fetchLouncherInstallerPending } from '../components/features/LauncherConfiguration/Download/download.slice';
import { IResponseGeneratorLouncherInstaller } from '../interface/interfaces';
import axios, { AxiosError } from 'axios';

const fetchData = (url: string) => {
    return axios.get(url, { responseType: 'blob' });
};

function* workerFetchLouncherInstaller(action: { type: string; payload: string }) {
    try {
        const response: IResponseGeneratorLouncherInstaller = yield call(fetchData, action.payload);
        const data = response.data;
        yield put(fetchLouncherInstallerFulfilled(data));
    } catch (err) {
        let error;
        let status = 500;
        if (err instanceof AxiosError) {
            if (err.response?.status) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                status = err.response?.status;
            }
            error = err.message;
        } else {
            error = err;
        }
        yield put(fetchLouncherInstallerFailure(`Failed to retrieve data: ${error}`));
    }
}

function* fetchLouncherInstaller() {
    yield takeLatest(fetchLouncherInstallerPending.type, workerFetchLouncherInstaller);
}

export default fetchLouncherInstaller;
